import type { FC } from 'react';
import React from 'react';
import { Col, Flex, FlexRow, Glyph } from '@edreamsodigeo/prisma-design-system';
import { useTranslation } from '@edreamsodigeo/frontend-core';
import { Text } from '@edreamsodigeo/prisma-design-system/deprecated';

export interface RibbonMessageProps {
  placement: 'card' | 'summary';
  withIcon: boolean;
  color?: string;
}
export interface TextBreakpoints {
  _: string;
  md: string;
  lg: string;
}

export interface RibbonTextProps {
  color: string;
  fontSize:
    | string
    | {
        [key in keyof TextBreakpoints | 'default']?: string;
      };
}

export const RibbonText: FC<RibbonTextProps> = ({ color, fontSize }) => {
  const { t } = useTranslation();

  return (
    <Text color={color} fontSize={fontSize} fontWeight="normal">
      {t('freeCancellation.pax.ribbon.label')}
    </Text>
  );
};

const RibbonMessage: FC<RibbonMessageProps> = ({
  placement = 'card',
  withIcon = false,
  color = 'white',
}) => {
  const fontSize =
    placement === 'card' ? { _: 'body.0', lg: 'body.1' } : 'body.1';

  return withIcon ? (
    <FlexRow flexDirection="row" alignItems="center" gap="1">
      <Col>
        <Glyph
          color={color}
          size={placement === 'card' ? { _: 'tiny', lg: 'small' } : 'small'}
          category="TimeAndDates"
          name="Future"
        />
      </Col>
      <Col>
        <RibbonText color={color} fontSize={fontSize} />
      </Col>
    </FlexRow>
  ) : (
    <Flex alignItems="center">
      <RibbonText color={color} fontSize={fontSize} />
    </Flex>
  );
};

export default RibbonMessage;
